import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Eye, EyeOff, Trash2 } from "lucide-react";
import { API, IMPIANTI } from "@/lib/config";
import { Stelle } from "@/components/Stelle";
import { dataIt } from "./InterventoCard";

export const RecensioniAdmin = ({ pwd }) => {
  const [items, setItems] = useState([]);
  const headers = { "X-Admin-Password": pwd };

  const carica = useCallback(() => {
    axios.get(`${API}/admin/recensioni`, { headers: { "X-Admin-Password": pwd } }).then((r) => setItems(r.data));
  }, [pwd]);
  useEffect(carica, [carica]);

  const toggle = async (r) => {
    await axios.patch(`${API}/recensioni/${r.id}`, { pubblicata: !r.pubblicata }, { headers });
    toast.success(r.pubblicata ? "Recensione nascosta" : "Recensione pubblicata"); carica();
  };
  const elimina = async (r) => {
    if (!window.confirm("Eliminare questa recensione?")) return;
    await axios.delete(`${API}/recensioni/${r.id}`, { headers });
    toast.success("Recensione eliminata"); carica();
  };

  if (!items.length) return (
    <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-12 text-center text-slate-500" data-testid="recensioni-admin-empty">
      Nessuna recensione ancora. Apri un intervento completato e invia il link al cliente.
    </div>
  );

  return (
    <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="recensioni-admin-list">
      {items.map((r) => (
        <article key={r.id} className={`rounded-2xl bg-white border p-5 space-y-3 ${r.pubblicata ? "border-slate-200" : "border-slate-200 opacity-60"}`} data-testid={`recensione-admin-${r.id}`}>
          <div className="flex justify-between items-center"><Stelle voto={r.voto} /><span className="text-xs font-bold uppercase tracking-wider text-slate-500">{r.pubblicata ? "Pubblicata" : "Nascosta"}</span></div>
          <p className="text-sm text-slate-700">“{r.testo}”</p>
          <p className="text-xs text-slate-500"><b className="text-slate-800">{r.nome_visibile}</b> · {r.tipo_problema} · {IMPIANTI[r.impianto]} · {dataIt(r.created_at)}</p>
          <div className="flex gap-2">
            <button onClick={() => toggle(r)} className="flex-1 h-9 inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-200 text-xs font-bold hover:bg-slate-50" data-testid={`recensione-toggle-${r.id}`}>
              {r.pubblicata ? <><EyeOff className="w-4 h-4" /> Nascondi</> : <><Eye className="w-4 h-4" /> Pubblica</>}
            </button>
            <button onClick={() => elimina(r)} className="h-9 px-3 inline-flex items-center gap-1.5 rounded-lg text-xs font-bold text-red-600 hover:bg-red-50" data-testid={`recensione-delete-${r.id}`}><Trash2 className="w-4 h-4" /> Elimina</button>
          </div>
        </article>
      ))}
    </div>
  );
};
